import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Heading from 'components/shared/heading';
import styles from './styles.module.scss';
import CheckIcon from './images/check.inline.svg';
import CrossIcon from './images/cross.inline.svg';

const SwiftlaneComparison = ({
  title = null,
  description = null,
  items = [],
  swiftlaneLabel = 'Swiftlane',
  competitorsLabel = 'Competitors',
}) => {
  const renderCellContent = (content, isSwiftlane = false) => {
    if (!content) return null;
    return (
      <div className={styles.text}>
        {isSwiftlane ? (
          <CheckIcon className={styles.icon} />
        ) : (
          <CrossIcon className={styles.icon} />
        )}
        {content}
      </div>
    );
  };

  return (
    <section className={styles.swiftlaneComparison}>
      <div className={styles.inner}>
        <div className="container">
          {title && (
            <Heading className={styles.title} tag="h2" size="xl">
              {title}
            </Heading>
          )}

          {description && <p className={styles.description}>{description}</p>}

          {items && items.length > 0 && (
            <div className={styles.tableContainer}>
              <div className={styles.table}>
                <div className={cn(styles.row, styles.header)}>
                  {items[0]?.feature && <div className={cn(styles.cell, styles.feature)} />}
                  <div className={cn(styles.cell, styles.swiftlane)}>{swiftlaneLabel}</div>
                  <div className={cn(styles.cell, styles.others)}>{competitorsLabel}</div>
                </div>

                {items.map((row, index) => (
                  <div className={styles.row} key={index}>
                    {row.feature && (
                      <div className={cn(styles.cell, styles.feature)}>{row.feature}</div>
                    )}
                    <div className={cn(styles.cell, styles.swiftlane)}>
                      <span className={styles.mobileLabel}>{swiftlaneLabel}:</span>
                      {renderCellContent(row.swiftlane, true)}
                    </div>
                    <div className={cn(styles.cell, styles.others)}>
                      <span className={styles.mobileLabel}>{competitorsLabel}:</span>
                      {renderCellContent(row.others, false)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

SwiftlaneComparison.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  swiftlaneLabel: PropTypes.string,
  competitorsLabel: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      feature: PropTypes.string.isRequired,
      swiftlane: PropTypes.string.isRequired,
      others: PropTypes.string.isRequired,
    })
  ),
};

export default SwiftlaneComparison;
